import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function EnvironmentalCompliance(props) {
    const { t } = useTranslation("translation");
    const environmentalComplianceList = [
        { code: false, description: t("CleanEnvironment") },
        { code: true, description: t("NotCleanEnvironment") },
    ];

    return (
        <Autocomplete
            id="EnvironmentalCompliance_a"
            onChange={(_event, newValue) => {
                if (newValue === t("CleanEnvironment")) {
                    props.handleEnvironmentalComplianceChange(false);
                } else if (newValue === t("NotCleanEnvironment")) {
                    props.handleEnvironmentalComplianceChange(true);
                } else if (newValue === null) {
                    props.handleEnvironmentalComplianceChange(null);
                }
            }}
            value={environmentalComplianceList.filter((item) => item.code === props.isEnvNotClean)[0]?.description ?? ""}
            defaultValue=""
            options={environmentalComplianceList.map((option) => option.description)}
            renderInput={(params) => <TextField id="EnvironmentalCompliance_t" {...params} margin="normal" label={t("EnvironmentalCompliance")} variant="outlined" />}
            size={props.size ?? "normal"}
        />
    );
}
